import { render, staticRenderFns } from "./uploadTaskList.vue?vue&type=template&id=f8bcf1be&scoped=true"
import script from "./uploadTaskList.vue?vue&type=script&lang=js"
export * from "./uploadTaskList.vue?vue&type=script&lang=js"
import style0 from "./uploadTaskList.vue?vue&type=style&index=0&id=f8bcf1be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bcf1be",
  null
  
)

export default component.exports